import { en } from './en'
import { fr } from './fr'

export const rsvpPage = {
  en,
  fr
}